import { Link } from "react-router-dom";
import { packages } from "@/mocks/products";

export default function Footer() {
  return (
    <footer className="bg-charcoal-900 text-charcoal-200">
      <div className="w-full px-6 md:px-10 lg:px-16 pt-16 pb-12">
        {/* Logo + Tagline */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-12">
          <div className="flex flex-col items-start leading-none">
            <span className="font-serif text-xl font-bold tracking-[0.12em] text-gold">
              PROPRE
            </span>
            <span className="font-serif text-sm font-normal tracking-[0.25em] text-gold -mt-0.5">
              Purification
            </span>
          </div>
        </div>

        {/* Navigation Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 pb-12 border-b border-dark-border">
          <div>
            <h4 className="text-sm font-sans font-semibold text-charcoal-50 mb-4">
              Packages
            </h4>
            <ul className="flex flex-col gap-3">
              {packages.map((pkg) => (
                <li key={pkg.id}>
                  <Link
                    to={`/packages#${pkg.id}`}
                    className="text-sm text-charcoal-300 hover:text-gold transition-colors duration-300 font-sans"
                  >
                    {pkg.tier}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-sans font-semibold text-charcoal-50 mb-4">
              Company
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-charcoal-300 hover:text-gold transition-colors duration-300 font-sans"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-charcoal-300 hover:text-gold transition-colors duration-300 font-sans"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/iowa-water-crisis"
                  className="text-sm text-charcoal-300 hover:text-gold transition-colors duration-300 font-sans"
                >
                  Iowa Water Crisis
                </Link>
              </li>
              <li>
                <span className="text-sm text-charcoal-300 font-sans">
                  Greater DSM Area
                </span>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-charcoal-300 hover:text-gold transition-colors duration-300 font-sans"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-sans font-semibold text-charcoal-50 mb-4">
              Support
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <a
                  href="mailto:info@proprepurification.com?subject=Support%20Request"
                  className="text-sm text-charcoal-300 hover:text-gold transition-colors duration-300 font-sans"
                >
                  Contact Support
                </a>
              </li>
              <li>
                <Link
                  to="/warranty"
                  className="text-sm text-charcoal-300 hover:text-gold transition-colors duration-300 font-sans"
                >
                  Warranty
                </Link>
              </li>
            </ul>
          </div>
          <div className="flex flex-col justify-between md:items-end">
            <div className="md:text-right">
              <p className="font-serif text-sm text-charcoal-50 mb-1">
                &copy; 2026 Propre Purification
              </p>
              <p className="text-xs text-charcoal-300 font-sans">
                All rights reserved
              </p>
            </div>
            <p className="font-serif text-lg md:text-xl text-charcoal-50 leading-snug mt-6 text-right">
              Pure water is not a luxury.
              <br />
              It is the foundation
              <br />
              of a healthy life.
            </p>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="w-full px-6 md:px-10 lg:px-16 pt-6">
          <p className="text-[11px] text-charcoal-400 font-sans leading-relaxed max-w-4xl">
            Our filtration systems are designed to reduce specific contaminants from drinking water.
            They are not intended to diagnose, treat, cure, or prevent any disease.
          </p>
        </div>
      </div>
    </footer>
  );
}